import React, { useEffect, useMemo, useContext, useCallback, useState } from 'react';
import { RenderElement } from 'components/RenderHelpers';
import atoms from 'ctsutheme/components/atoms';
import { CanUserAccessAdmin, CanUserEditOPENRelations } from 'appconstants/Permission';
import { TE } from 'appconstants';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getOpenSetup, getRelations } from 'actions/protocols/opensetup';
import { bindLogger } from 'helpers/BindLogger';
import { AppContext } from '@ctsu/loader';
import { getProtocolDetails } from 'actions/protocols/protocoldetail';
import { useParams } from 'react-router';
import RSSDialog from 'containers/modal/components/RSSDialog';
import { FasPlus } from 'assets/icons';
import { AddEmbeddedNpStudy } from './AddEmbeddedNpStudy';

const { Button } = atoms;

const CreateEmbeddedNpStudy = () => {

    const dispatch = useDispatch();
    const [openModal, setOpenModal] = useState(false);
    const protocolNumber = useParams()?.id;
    const openConfigs = useSelector(s => s.openData?.openData?.openConfig);
    const protInfo = useSelector(s => s.prtDetails.prtInfo);

    const prtRelationsArr = useSelector(s => s.openData.relations);

    const context = useContext(AppContext);

    const actions = useMemo(() => bindActionCreators({
        getOpenSetup,
        getProtocolDetails,
        getRelations
    }, dispatch), [dispatch]);

    const protocolNum = useMemo(() => protocolNumber, [protocolNumber]);
    const isProtocolNpClaimed = useMemo(() => {
        return prtRelationsArr?.some ? prtRelationsArr.some(({ relatedProtocolNumber }) => relatedProtocolNumber.includes('-NP')) : [];
    }, [prtRelationsArr]);

    const fetchProtocolInformations = useCallback(() => {
        if (protocolNum) {
            bindLogger(actions.getOpenSetup, context)(protocolNumber);
            bindLogger(actions.getProtocolDetails, context)(protocolNumber);
            bindLogger(actions.getRelations, context)(protocolNumber);
        }
    }, [actions, protocolNum, context]);

    useEffect(() => {
        fetchProtocolInformations()
    }, [fetchProtocolInformations])

    const handleNpStudy = () => {
        setOpenModal(true);
    }

    const isDisabled = !(openConfigs?.isCcdr && !isProtocolNpClaimed && protInfo.grpProtStatus !== 'FDAAA/IRB Completed');

    return <RenderElement access={CanUserAccessAdmin() || CanUserEditOPENRelations()}>
        <Button
            title="Create Embedded NP Study"
            variant="outlined"
            color="primary"
            name="Create Embedded NP Study"
            disabled={isDisabled}
            data-id={`${TE.ID}handle-np-study${TE.BTN}`}
            onClick={handleNpStudy}
            className="turquoise ml-1"
          >
            <FasPlus className="ml-n1 mr-1" />
            Embedded NP Study
        </Button>
        <RSSDialog
            title="Create Embedded NP Study"
            show={openModal}
            onClose={() => setOpenModal(false)}
        >
            {openModal ? <AddEmbeddedNpStudy
                onClose={() => setOpenModal(false)}
                reloadPage={fetchProtocolInformations} /> : null}
        </RSSDialog>
    </RenderElement>
}

export default CreateEmbeddedNpStudy;
